<ng-container>
  <div class="main-container">
    <div class="title">
      <h1>
        {{ ((facade.addExistingUser$ | async) ? 'title.add_existing_user' : 'title.create_user') | translate | uppercase
        }}
      </h1>
    </div>

    <!-- Title -->
    <div class="card">
      <div *ngIf="facade.organizationLimitReached$ | async" class="error-message" data-cy="organization-limit-banner">
        <div class="error-title">{{ 'warning.organization_limit_reached_title' | translate }}</div>
        <div>{{ 'warning.organization_limit_reached_message' | translate }}</div>
      </div>
      <ng-container>
        <div class="card-body" *ngIf="(facade.isAdmin$ | async) && (facade.addExistingUser$ | async) === false">
          <div>
            <mat-checkbox [ngModel]="facade.registerWithoutEmail$ | async"
              (ngModelChange)="toggleRegisterWithoutEmail($event)" class="text-danger"
              data-cy="check-register-userpassword">
              {{ 'label.register_without_email' | translate }}
            </mat-checkbox>
          </div>
        </div>
      </ng-container>
      <div *ngIf="facade.userForm$ | async as userForm">
        <div class="card-body">
          <!-- Adding an existing user: a single field accepts either a username or an email. -->
          <ng-container *ngIf="(facade.addExistingUser$ | async); else createUserFields">
            <mat-form-field class="full-width">
              <input matInput autofocus id="user-editor-username-or-email-input" type="text" autocomplete="off"
                placeholder="{{ 'label.username_or_email' | translate | uppercase }}" [ngModel]="userForm.username"
                (ngModelChange)="facade.setFormUsername($event)" data-cy="input-username-or-email" />
            </mat-form-field>
          </ng-container>
          <ng-template #createUserFields>
            <ng-container *ngIf="(facade.registerWithoutEmail$ | async) === false; else usernameInput">
              <mat-form-field class="full-width">
                <input matInput autofocus id="user-editor-email-input" type="email" autocomplete="off"
                  placeholder="{{ 'label.email' | translate | uppercase }}" data-cy="input-email"
                  [ngModel]="userForm.email" (ngModelChange)="updateEmail($event)" />
              </mat-form-field>
              <mat-form-field class="full-width">
                <input matInput id="user-editor-username-input" type="text" autocomplete="off"
                  placeholder="{{ 'label.username' | translate | uppercase }}" data-cy="input-username"
                  [ngModel]="userForm.username" disabled="true" />
              </mat-form-field>
            </ng-container>
            <ng-template #usernameInput>
              <mat-form-field class="full-width">
                <input matInput autofocus id="user-editor-username-input" type="text" autocomplete="off"
                  placeholder="{{ 'label.username' | translate | uppercase }}" [ngModel]="userForm.username"
                  (ngModelChange)="facade.setFormUsername($event)" data-cy="input-username" />
              </mat-form-field>
              <mat-form-field class="full-width">
                <input matInput id="user-editor-password-input" [type]="hidePassword ? 'password' : 'text'"
                  autocomplete="off" placeholder="{{ 'label.password' | translate | uppercase }}"
                  [ngModel]="userForm.password" (ngModelChange)="facade.setFormPassword($event)"
                  data-cy="input-password" />
                <button mat-icon-button matSuffix type="button" (click)="togglePasswordVisibility()"
                  [attr.aria-label]="'Toggle password visibility'" [attr.aria-pressed]="!hidePassword"
                  style="margin-right: 8px">
                  <i [class]="hidePassword ? 'ri-eye-off-line' : 'ri-eye-line'" style="font-size: 18px"></i>
                </button>
              </mat-form-field>
            </ng-template>
          </ng-template>
          <!-- Roles are global; an existing user keeps theirs, so the selector is hidden. -->
          <ts-role-switchers *ngIf="(facade.addExistingUser$ | async) === false" [options]="roles$ | async"
            [loading]="loadingRoles$ | async" [enabled]="facade.updatedRoles$ | async" (granted)="grantRole($event)"
            (revoked)="revokeRole($event)"></ts-role-switchers>
        </div>
        <div class="card-body">
          <div id="workspaces-label" class="text-uppercase">
            {{ 'title.workspaces' | translate }} ({{ 'core.optional' | translate }})
          </div>
          <ts-workspace-selector *ngIf="{
              options: facade.workspaces$ | async,
              selected: facade.selectedWorkspaces$ | async,
              totalSelected: facade.selectedWorkspacesCount$ | async,
              total: facade.totalWorkspaces$ | async,
              loaded: (facade.hasMoreWorkspaces$ | async) === false,
              hasMore: facade.hasMoreWorkspaces$ | async
            } as state" [options]="state.options" [selected]="state.selected" [totalSelected]="state.totalSelected"
            [totalAvailable]="state.total" (added)="addToWorkspaces($event)" (removed)="removeFromWorkspaces($event)"
            [loaded]="state.loaded" (lastItemReached)="loadMoreWorkspaces(state.hasMore)"
            (selectAllAcrossPages)="loadAllWorkspaces()" [searchTerm]="initialWorkspaceSearchTerm"
            (searchTermChanged)="searchWorkspace($event)"></ts-workspace-selector>
        </div>
        <div class="card-body">
          <div *ngIf="facade.error$ | async as error">
            {{ error }}
          </div>
        </div>
        <div class="card-footer card-actions no-hr">
          <button type="button" class="btn btn-outline-primary card-actions__action" (click)="navigateToUsers()"
            data-cy="button-cancel-user">
            <i class="ri-close-fill"></i>
            {{ 'button.cancel' | translate }}
          </button>
          <ng-container>
            <button type="button" class="btn btn-primary card-actions__action" [disabled]="
                (facade.userFormIsValid$ | async) === false ||
                (facade.hasChanges$ | async) === false ||
                (facade.organizationLimitReached$ | async) === true
              " (click)="createUser()" data-cy="button-save-new-user">
              <i class="ri-save-line"></i>
              {{ 'button.create' | translate }}
            </button>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</ng-container>
